import { render, staticRenderFns } from "./ClinicsList.vue?vue&type=template&id=2ba96eec&scoped=true&"
import script from "./ClinicsList.vue?vue&type=script&lang=ts&"
export * from "./ClinicsList.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicsList.vue?vue&type=style&index=0&id=2ba96eec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba96eec",
  null
  
)

export default component.exports